import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import is from 'is_js';
import FlexBox from '../FlexBox';
import withI18n from '../../utils/withI18n';
import zIndexScale from '../../utils/zIndexScale';
import Balance from './Balance';
import { getLabel } from '../../utils/i18n';

const StyledFormRow = styled(FlexBox)`
  background: none;
  display: flex;
  margin: ${({ margin }) => margin || '0 0 5px 0'};
  padding-bottom: ${({ first }) => first ? '5px' : '0'};
  flex-basis: ${({ height }) => height ? `${height}px` : '25px'}; /* TODO: temporary */
  flex-wrap: nowrap;

${({ last }) => last ? `
  ` : ''}
  &:first-child {
    margin-top: 0;
  }
  & > h3 {
    font-weight: bolder;
    font-size: 15px; /* TODO: temporary */
    line-height: 1;
  }
  & input {
    box-shadow: none; /* no red outline in firefox. */
    flex: 1 1 auto;
    height: 100%;
    &[disabled] {
      filter: brightness(0.97);
      cursor: not-allowed;
    }
  }
  & > label {
    display: flex;
    align-items: center;
    flex-basis: 25%;
  }
  & > button {
    flex: 1;
    border: 1px solid ${({ theme }) => theme.inputBorder || '#d4d4d4'};
  }
`;

const StyledInput = styled.input`
  background: ${({ theme, invalid }) => invalid ? theme.errorInputBg : theme.buttonbg};
  border: 1px solid ${({ theme, invalid }) => invalid ? theme.errorInputBorderColor : theme.inputBorder};
  padding: 0 0 0 10px;
  color: ${({ theme }) => theme.fontColor};
  outline: none;
  :focus {
    border-color: ${({ theme }) => theme.activeBorder};
  }

`;
const StyledLabel = styled.label`
  color: ${({ theme }) => theme.fontColor1};
`;


const HeadingBox = styled(FlexBox)`
  width:100%;
  h3 {
    font-weight:bold;
    font-size: 14px;
  }
`;

const InputWrap = styled(FlexBox)`
  flex-basis: ${({ last }) => last ? '100%' : '75%'};
  position: relative;
  flex-wrap: nowrap;
  & >input[type=text],input[type=number] {
    width: 100%;
  }
`;

const MaxQuantityBox = styled.div`
  background: ${({ theme }) => theme.FormRow.MaxQuantityBoxBg};
  font-size:12px;
  color: ${({ theme }) => theme.FormRow.MaxQuantityBoxColor};
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  text-align:left;
  position:absolute;
  right:0;
  top:30px;
  z-index: ${zIndexScale.hint};
  width:100%;
  box-sizing:border-box;
`;

const FiatPriceBox = styled.div`
    padding: 4px 6px;
    border-radius:3px;
    background: ${({ theme }) => theme.FormRow.FiatPriceBoxBg};
    color: ${({ theme }) => theme.FormRow.FiatPriceBoxColor};
    position: absolute;
    left: 0;
    bottom: 10px;
    transform: translateY(-100%);
    & :after {
        content: " ";
        border: 6px solid transparent;
        border-top-color: ${({ theme }) => theme.FormRow.FiatPriceBoxBg};
        position: absolute;
        bottom: -11px;
        left: 50%;
        margin-left: -5px;
        z-index: ${zIndexScale.hint};
      }
  `;

const UnitBox = styled.span`
    color: ${({ theme }) => theme.fontColor3};
    font-size :12px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  `;

/* eslint-disable react/prop-types */
export default
@withI18n
class FormRow extends PureComponent {
  static propTypes = {
    i18n: PropTypes.object,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    i18n: {},
    onChange: () => {},
  }

  state = {
    showTip: false,
  }

  _onFocus = ev => {
    const { onFocus } = this.props;
    if (onFocus) {
      this.props.onFocus();
    }
    if (
      (ev.target.name === 'price' && ev.target.value !== '')
      || (ev.target.name === 'stop' && ev.target.value !== '')
      || (ev.target.name === 'limit' && ev.target.value !== '')
      || ev.target.name === 'quantity'
    ) {
      this.setState({
        showTip: true,
      });
    } else {
      this.setState({
        showTip: false,
      });
    }
  }

  _onBlur = () => {
    this.setState({
      showTip: false,
    });
  }

  _onPaste = (e) => {
    e.preventDefault();
    return false;
  }

  render() {
    const {
      heading,
      label,
      name,
      value,
      onChange,
      noLabel,
      last,
      first,
      disabled,
      readonly,
      placeholder,
      children,
      tickSize,
      minTrade,
      className,
      assetName,
      balance,
      i18n,
      side,
      mostAmount,
      fiatPrice,
      unit,
      invalid,
      height,
      margin,
      pair,
      orderType,
    } = this.props;
    const { showTip } = this.state;
    const tooltipContent = name !== 'quantity' ?
      <FiatPriceBox>{fiatPrice}</FiatPriceBox> :
      <MaxQuantityBox>
        {side === 'BUY' ?
          getLabel('exchange-common-mostBuy', i18n, 'Max Buy')
          : getLabel('exchange-common-mostSell', i18n, 'Max Sell')} {mostAmount}
      </MaxQuantityBox>;
    // `side` is used to generate form label id
    if (is.string(label) && !side) {
      throw new Error(`FormRow: 'side' is a required prop for ${label}`);
    }
    const id = `FormRow-${side}-${name}`;
    return (
      <StyledFormRow
        flex="0"
        margin={margin}
        last={last}
        first={first}
        height={height}
        className={className}
      >
        {heading ? (
          <HeadingBox justify="space-between" align="center">
            <h3>{heading}</h3>
            <Balance balance={balance} assetName={assetName} pair={pair} side={side} orderType={orderType} />
          </HeadingBox>
        ) : null}
        {is.string(label) || noLabel ? (
          <Fragment>
            {!noLabel ? (
              // eslint-disable-next-line jsx-a11y/label-has-for
              <StyledLabel htmlFor={id}>
                {label}{label ? ':' : null}
              </StyledLabel>) : null}
            <InputWrap last={last}>
              {!children ? (
                <StyledInput
                  type={placeholder ? 'text' : 'number'}
                  id={id}
                  name={name}
                  value={placeholder || value || ''}
                  onChange={onChange}
                  disabled={disabled}
                  readOnly={readonly}
                  step={tickSize}
                  min={minTrade}
                  onFocus={this._onFocus}
                  onBlur={this._onBlur}
                  invalid={invalid}
                  onPaste={this._onPaste}
                />
              ) : children}
              {unit ? <UnitBox>{unit}</UnitBox> : null}
              {showTip ? tooltipContent : null}
            </InputWrap>
          </Fragment>) : null}
      </StyledFormRow>
    );
  }
}
